module.exports = {"ru":{"expand":"Раскрыть все","collapse":"Скрыть все"},"en":{"expand":"Expand all","collapse":"Collapse all"}}


//////////////////
// WEBPACK FOOTER
// ./temp/components/accordions/text.yaml
// module id = 127
// module chunks = 0